import PropTypes from "prop-types";

import Icon from "components/ShellV2/Icon";

/* Vertical side-tab navigation that switches panels (port of the design's
   SideTabs). Unlike AnchorNav this does not scroll — the parent decides what
   to render for the active tab. */
export default function SideTabs({ items, active, onChange, children }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[220px_1fr] items-start gap-rec">
      <nav className="rec-anchor-nav">
        {items.map((it) => (
          <a
            key={it.id}
            href={`#${it.id}`}
            className={active === it.id ? "on" : ""}
            onClick={(e) => {
              e.preventDefault();
              onChange(it.id);
            }}
          >
            <Icon name={it.icon} />
            {it.label}
          </a>
        ))}
      </nav>
      <div className="flex flex-col gap-rec min-w-0">{children}</div>
    </div>
  );
}

SideTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    })
  ).isRequired,
  active: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node,
};

SideTabs.defaultProps = {
  children: null,
};
